import type { KmContextItem, KmContextLevel, KmContextSource, KmContextSourceKind } from '../model/api/types';

/** Вид уровня заключения, чей контекст оценки читается или правится */
export const getKmContextLevelKind = (level: KmContextLevel): KmContextSourceKind => {
  if (typeof level.assessmentId === 'number') return 'assessment';
  if (typeof level.groupId === 'number') return 'group';
  return 'report';
};

/** Уровень пути, которым в контексте назван сам прочитанный уровень */
const isLevelSource = (source: KmContextSource, level: KmContextLevel): boolean =>
  source.kind === getKmContextLevelKind(level) && source.id === (level.assessmentId ?? level.groupId ?? level.reportId);

/** Контекст оценки уровня, разделённый на назначенное самому уровню и пришедшее сверху */
type KmContextParts = {
  /** Назначенное на самом уровне, включая то, что приходит и сверху */
  own: KmContextItem[];
  /** Пришедшее сверху и на самом уровне не назначенное */
  inherited: KmContextItem[];
};

/**
 * Делит контекст уровня на свой и пришедший сверху. Атрибут в контексте один раз, поэтому назначенный
 * и на уровне, и выше остаётся только среди своих — повтором.
 */
export const splitKmContextItems = (items: KmContextItem[], level: KmContextLevel): KmContextParts => {
  const own: KmContextItem[] = [];
  const inherited: KmContextItem[] = [];

  for (const item of items) {
    if (item.sources.some((source) => isLevelSource(source, level))) {
      own.push(item);
    } else {
      inherited.push(item);
    }
  }

  return { own, inherited };
};

/** Уровни выше прочитанного, с которых приходит атрибут: у своего атрибута непустой список означает повтор */
export const getKmContextUpperSources = (item: KmContextItem, level: KmContextLevel): KmContextSource[] =>
  item.sources.filter((source) => !isLevelSource(source, level));
